import { Grid, Typography } from "@mui/material";

import React from "react";
import { NavLink } from "react-router-dom";
import ReactTypingEffect from "react-typing-effect";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
const Home = () => {
  return (
    <div className="home-wrapper">
      <div className="upper-body">
        <Grid container className="heading flex flex-col items-center p-4">
          <Grid item lg={7} md={7}>
            <div>
              <div className="title px-3">
                <Typography variant="h4" component="h4">
                  Hello my name is,{" "}
                  <Typography variant="h4" component="span">
                    Pruthvi Patel
                  </Typography>
                </Typography>
              </div>
              <div className="typing-effect mt-8 md:mt-4 flex px-3">
                <h4 className=" text-white text-xl">
                  I am{" "}
                  <ReactTypingEffect
                    speed={100}
                    eraseSpeed={100}
                    eraseDelay={2000}
                    text={["Data Science enthusiast.", "Full Stack Developer."]}
                  />
                </h4>
              </div>
              <div className="about-info mt-2 px-3">
                <h4>
                  As a <span className="ml-2 mr-2">full-stack developer</span>
                  with a strong focus on
                  <span className="ml-2 mr-2">
                    data science and engineering,
                  </span>
                  I'm driven by a passion for leveraging technology to create
                  impactful solutions and am currently advancing my expertise in
                  data technologies, I’m dedicated to using my skills to make a
                  positive global impact. Let’s collaborate to turn visionary
                  ideas into reality.
                </h4>
              </div>
              <div className="mt-10 px-3" id="know_more_btn">
                <NavLink to={"/About"}>
                  <button className=" primary-btn ">Know More</button>
                </NavLink>
              </div>
            </div>
          </Grid>
          <Grid item lg={1} md={1}></Grid>
          <Grid item lg={4} md={4} className="w-full  flex justify-center">
            <div className="home-image ">
              <img
                src={"/assest/images/person_computer.png"}
                alt="computer_vector"
                // height={400}
                // width={400}
              />
            </div>
          </Grid>
        </Grid>
        <div className=" mt-8 md:mt-4 flex justify-center  items-enter">
          <div className="flex justify-between  w-2/4 md:w-1/5 items-enter">
            <a
              href={"https://github.com/PruthviPatel2001"}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="border  text-white hover:bg-white hover:text-[#1d2549] rounded-[50%] p-2"
                id="icon"
              >
                <GitHubIcon style={{ fontSize: "2rem " }} />
              </div>
            </a>

            <a
              href={"https://www.linkedin.com/in/pruthvi-s-patel"}
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="border text-white hover:bg-white hover:text-[#1d2549]   rounded-[50%] p-2"
                id="icon"
              >
                <LinkedInIcon style={{ fontSize: "2rem " }} />
              </div>
            </a>

            <a
              href={
                "https://www.instagram.com/pruthvi1221/?igshid=YmMyMTA2M2Y%3D"
              }
              target="_blank"
              rel="noreferrer"
            >
              <div
                className="border text-white hover:bg-white hover:text-[#1d2549] rounded-[50%] p-2"
                id="icon"
              >
                <InstagramIcon style={{ fontSize: "2rem " }} />
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
